import React, { useState } from "react";

import { Documents } from "icons";

import { Tab, Button, Typography } from "clearsense-ui/components";

import Edit from "./Edit";
import History from "./History";

const PrimaryTabs = ({
  data,
  searchParams,
  isPDFPresent,
  isViewMode,
  userPermissions,
  currentPdfName,
  updateData,
  setIsViewPdf,
}) => {
  const [activeTab, setActiveTab] = useState("edit");

  return (
    <div>
        <Typography style="h4" type="semibold">
          NPI PDF Document
        </Typography>
        {isPDFPresent ? (
            <Button
              style="secondary"
              label={`View ${currentPdfName}`}
              icon={() => <Documents size={24} />}
              className="text-primary-shade hover:text-white text-sm mt-2 mb-4"
              onClick={() => setIsViewPdf(true)}
            />
            ):(
              <Typography className="text-red-600 mb-8">
                  Credentialing image/file does not exist.
              </Typography>
        )}
      <Typography style="h4" type="semibold">
        NPI Details
      </Typography>
      <Tab style="secondary">
        <Tab.Item
          active={activeTab === "edit"}
          onClick={() => setActiveTab("edit")}
        >
          Details: {searchParams.credentialing_dashboard.npi}
        </Tab.Item>
        <Tab.Item
          active={activeTab === "history"}
          onClick={() => setActiveTab("history")}
        >
          History
        </Tab.Item>
      </Tab>
      {activeTab === "edit" && (
        <Edit
          data={data}
          searchParams={searchParams}
          isViewMode={isViewMode}
          userPermissions={userPermissions}
          updateData={updateData}
        />
      )}
      {activeTab === "history" && <History data={data} />}
    </div>
  );
};

export default PrimaryTabs;
